import { toRgba } from "../to-rgba/to-rgba.mjs";
//#region packages/@mantine/core/src/core/MantineProvider/color-functions/rgba/rgba.ts
function rgba(color, alpha) {
	if (typeof color !== "string" || alpha > 1 || alpha < 0) return "rgba(0, 0, 0, 1)";
	if (color.startsWith("var(")) return `color-mix(in srgb, ${color}, transparent ${(1 - alpha) * 100}%)`;
	if (color.startsWith("oklch")) {
		if (color.includes("/")) return color.replace(/\/\s*[\d.]+\s*\)/, `/ ${alpha})`);
		return color.replace(")", ` / ${alpha})`);
	}
	const { r, g, b } = toRgba(color);
	return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}
const alpha = rgba;
//#endregion
export { alpha, rgba };

//# sourceMappingURL=rgba.mjs.map